/** @format */
import { NamedException } from '@toucan/client/global/application';

export async function withNamedTryCatch<T = unknown>(
    method: () => T,
    id: string
): Promise<T> {
    try {
        return await method();
    } catch (error) {
        throw new NamedException(id, error);
    }
}
